import { z } from 'zod';
import { metaSchema } from './meta-schema';
import { tagSchema } from './tag-schema';

export type TTableOfContents = z.infer<typeof tableOfContentsSchema>;

export const tableOfContentsTypeSchema = z.enum([
  'vendor',
  'product',
  'district',
  'county',
  'city',
]);
export type TTableOfContentsType = z.infer<typeof tableOfContentsTypeSchema>;

export const tableOfContentsSchema = z.object({
  name: z.string(),
  slug: z.string(),
  hideTitle: z.boolean(),
  type: tableOfContentsTypeSchema,
  meta: metaSchema,
  tags: z.object({ data: z.array(tagSchema) }),
});
